import { defaultTrainSDK } from '@train-protocol/sdk';
import { defaultTrainAuth } from '@train-protocol/auth';
import { SolanaHTLCPublicClient, SolanaHTLCWalletClient } from './client/index.js';
import { deriveKeyFromSolanaWallet } from './login/index.js';
export { SolanaHTLCPublicClient, SolanaHTLCWalletClient } from './client/index.js';
export { deriveKeyFromSolanaWallet } from './login/index.js';
export { TrainHtlc } from './idl/trainHtlc.js';
export function registerSolanaSdk(sdk, auth) {
    const s = sdk ?? defaultTrainSDK;
    const a = auth ?? defaultTrainAuth;
    s.registerHTLCPublicClient('solana', (config) => new SolanaHTLCPublicClient(config));
    s.registerHTLCWalletClient('solana', (config) => new SolanaHTLCWalletClient(config));
    a.registerWalletSign('solana', async (config) => {
        return deriveKeyFromSolanaWallet(config.wallet);
    });
}
